//import moment from 'moment';  in use

export default {
    data() {
        return {
            currentweek: 0, 
            title: '',       
        }   
    },

    methods: {
        createBarData(arr_ty, arr_py, arr_py3) {

            //console.log(arr_py) ;
            console.log(arr_ty.length, arr_py.length, arr_py3.length);
            let xvalues_ty = [], barcolors_ty = [],  bordercolors_ty = [], yvalues_ty = [], maxvalue_ty = 0, maxvalue = 0;
            let yvalues_py = [], barcolors_py = [],  bordercolors_py = [], maxvalue_py=0;
            let yvalues_py3 = [], barcolors_py3 = [],  bordercolors_py3 = [], maxvalue_py3=0;
            //this.currentweek = this.getCurrentWeekNum();            

            for (let i = 0; i < arr_ty.length; i++) {
                yvalues_ty.push(arr_ty[i].nr_arrivals)
                if(arr_ty.length > arr_py.length){ // this year has week 53, use this year for x-axis
                    xvalues_ty.push(arr_ty[i].week);
                }
                if (arr_ty[i].nr_arrivals > maxvalue_ty) {
                    maxvalue_ty = arr_ty[i].nr_arrivals;
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                yvalues_py.push(arr_py[i].nr_arrivals)
                if(arr_py.length >= arr_ty.length){ // previous year has week 53, use this year for x-axis
                    xvalues_ty.push(arr_py[i].week);
                }
                if (arr_py[i].nr_arrivals > maxvalue_ty) {
                    maxvalue_ty = arr_py[i].nr_arrivals; // also check here for a max value
                }
                if (arr_py[i].nr_arrivals > maxvalue_py) {
                    maxvalue_py = arr_py[i].nr_arrivals; 
                }                
            }

            for (let i = 0; i < arr_py3.length; i++) {
                yvalues_py3.push(arr_py3[i].nr_arrivals)
                if(arr_py3.length >= arr_ty.length){ // previous year has week 53, use this year for x-axis
                    xvalues_ty.push(arr_py3[i].week);
                }
                if (arr_py3[i].nr_arrivals > maxvalue_ty) {
                    maxvalue_ty = arr_py3[i].nr_arrivals; // also check here for a max value
                }
                if (arr_py3[i].nr_arrivals > maxvalue_py3) {
                    maxvalue_py3 = arr_py3[i].nr_arrivals; 
                }                
            }

            xvalues_ty = [];
            if(arr_py.length > arr_ty.length){
                if(arr_py3.length > arr_py.length){
                    // vullen n.a.v. arr_py3
                    arr_py3.forEach(x => {xvalues_ty.push(x.week)});
                } else {
                    // vullen n.a.v. arr_py
                    arr_py.forEach(x => {xvalues_ty.push(x.week)});
                }
            } else {
                // vullen n.a.v. arr_ty
                arr_ty.forEach(x => {xvalues_ty.push(x.week)});
            }

            console.log("x values", xvalues_ty);

            maxvalue = maxvalue_ty;

            var section = [];
            section[3] = maxvalue;
            section[2] = maxvalue - (maxvalue / 4);
            section[1] = maxvalue - (2 * (maxvalue / 4));
            section[0] = maxvalue / 4;

            var section_py = [];
            section_py[3] = maxvalue_py;
            section_py[2] = maxvalue_py - (maxvalue_py / 4);
            section_py[1] = maxvalue_py - (2 * (maxvalue_py / 4));
            section_py[0] = maxvalue_py / 4;

            var section_py3 = [];
            section_py3[3] = maxvalue_py3;
            section_py3[2] = maxvalue_py3 - (maxvalue_py3 / 4);
            section_py3[1] = maxvalue_py3 - (2 * (maxvalue_py3 / 4));
            section_py3[0] = maxvalue_py3 / 4;            

            for (let i = 0; i < arr_ty.length; i++) {
                var found = false;
                for (let t = 0; t < section.length; t++) {
                    if(!found){
                        if(arr_ty[i].nr_arrivals <= section[t]){
                            switch (t) {
                                case 0:
                                    barcolors_ty.push("rgba(50,205,50,0.5)"); // ok  
                                    bordercolors_ty.push("rgb(50,205,50)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_ty.push("rgba(60,179,113,0.5)"); // busy
                                    bordercolors_ty.push("rgb(60,179,113)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_ty.push("rgba(46,139,87,0.5)"); // really busy
                                    bordercolors_ty.push("rgb(46,139,87)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_ty.push("rgba(0,128,0,0.5)"); // insane
                                    bordercolors_ty.push("rgb(0,128,0)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                found = false;
                for (let t = 0; t < section_py.length; t++) {
                    if(!found){
                        if(arr_py[i].nr_arrivals <= section_py[t]){
                            switch (t) {
                                case 0:
                                    barcolors_py.push("rgba(0,191,255,0.5)"); // ok  
                                    bordercolors_py.push("rgb(0,191,255)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_py.push("rgba(100,149,237,0.5)"); // busy
                                    bordercolors_py.push("rgb(100,149,237)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_py.push("rgba(30,144,255,0.5)"); // really busy
                                    bordercolors_py.push("rgb(30,144,255)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_py.push("rgba(65,105,225,0.5)"); // insane
                                    bordercolors_py.push("rgb(65,105,225)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }            


            for (let i = 0; i < arr_py3.length; i++) {
                found = false;
                for (let t = 0; t < section_py3.length; t++) {
                    if(!found){
                        if(arr_py3[i].nr_arrivals <= section_py3[t]){
                            switch (t) {
                                case 0:
                                    barcolors_py3.push("rgba(252,214,112,0.5)"); // ok  
                                    bordercolors_py3.push("rgb(243,156,18)"); // ok  
                                    found=true;
                                    break;
                                case 1:
                                    barcolors_py3.push("rgba(249,191,59,0.5)"); // busy
                                    bordercolors_py3.push("rgb(235,149,50)"); // busy
                                    found=true;
                                    break;
                                case 2:
                                    barcolors_py3.push("rgba(243,156,18,0.5)"); // really busy
                                    bordercolors_py3.push("rgb(230,126,34)"); // really busy
                                    found=true;
                                    break;
                                case 3:
                                    barcolors_py3.push("rgba(230,126,34,0.5)"); // insane
                                    bordercolors_py3.push("rgb(242,120,75)"); // insane
                                    found=true;
                                    break;
                            }
                        }
                    }
                }
            }             
            
            console.log(yvalues_py3, yvalues_py, yvalues_ty);

            let datasets = [];
            var currentYear = new Date().getFullYear();

            let dataset_element;

            dataset_element = {
                "backgroundColor": barcolors_py3,
                "hoverBackgroundColor": "rgba(249,191,59,0.3)",
                "data": yvalues_py3,
                "borderColor": bordercolors_py3,
                "hoverBorderColor": "rgba(243,156,18,1)",
                "label": "Arrivals " + (currentYear - 2),
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            dataset_element = {
                "backgroundColor": barcolors_py,
                "hoverBackgroundColor": "rgba(70,130,180,0.3)",
                "data": yvalues_py,
                "borderColor": bordercolors_py,
                "hoverBorderColor": "rgba(70,130,180,1)",
                "label": "Arrivals " + (currentYear - 1),
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            dataset_element = {
                "backgroundColor": barcolors_ty,
                "hoverBackgroundColor": "rgba(34,139,34,0.3)",
                "data": yvalues_ty,
                "borderColor": bordercolors_ty,
                "hoverBorderColor": "rgba(34,139,34,1)",
                "label": "Arrivals " + currentYear,
                "borderWidth": 1,
                "pointStyle": "circle",
                "pointRadius": 3,
                "pointHoverRadius": 8,                
            };
            datasets.push(dataset_element);

            let xdata = {
                "labels": xvalues_ty,
                "datasets": datasets,
            };

            let xminmax = {
                "min": 0,
                "max": maxvalue + 50,
            };

            let xscales = { "y": xminmax };
            let xlegend = {
                "legend": {
                    "display": true
                },
                datalabels: {
                    formatter: function(value, context){
                        return context !== null ? value === 0 ? '' : '': '';                         
                    }
                }                                    
            };

            let xoptions = {
                "plugins": xlegend,
                "responsive": true,
                "maintainAspectRatio": false,
                "lineTension": 0,
                "scales": xscales,
            };

            let chartData = {
                "type": "line",
                "data": xdata,
                "options": xoptions,
            };

            return chartData;

        },
        // getCurrentWeekNum(){
        //     var currentDate = new Date();
        //     var startDate = new Date(currentDate.getFullYear(), 0, 1);
        //     var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));                
        //     return Math.ceil(days / 7);
        // },
    }
}